import {
  DEFAULT_WHITEBOARD_PANEL_REGISTRY,
  type WhiteboardPanelRegistry,
} from 'agentable-canvas/whiteboard';

/** Stable module-scope registry — extends agentable defaults with Canvas Studio panels. */
export const CANVAS_STUDIO_PANEL_REGISTRY: WhiteboardPanelRegistry = {
  ...DEFAULT_WHITEBOARD_PANEL_REGISTRY,
  chat: () =>
    import('../components/panels/OnboardingChatPanel').then((m) => ({
      default: m.OnboardingChatPanel,
    })),
  'project-brief': () =>
    import('../components/panels/ProjectBriefPanel').then((m) => ({
      default: m.ProjectBriefPanel,
    })),
  'web-preview': () =>
    import('../components/panels/DraftPreviewPanel').then((m) => ({
      default: m.DraftPreviewPanel,
    })),
  'file-manager': () =>
    import('../components/panels/FileManagerPanel').then((m) => ({
      default: m.FileManagerPanel,
    })),
  'all-sites': () =>
    import('../components/panels/AllSitesPanel').then((m) => ({
      default: m.AllSitesPanel,
    })),
};
